module.exports = __webpack_public_path__ + "static/media/pm_up_arrow_grey.f0f4b7e6.svg";